import isUndefined from "lodash/isUndefined";
import getDate from "date-fns/get_date";
import getMonth from "date-fns/get_month";
import getYear from "date-fns/get_year";

export const filterTravelersWithBirthday = (travelers, callback) => {
    const travelersWithBirthday = [];

    if(travelers && !isUndefined(travelers) && travelers.count < 30 && travelers.count !== 0 && travelers.travelers && Array.isArray(travelers.travelers)) {
        travelers.travelers.map((traveler) => {
            const dayOfBirth = getDate(new Date(traveler.birthday));
            const monthOfBirth = getMonth(new Date(traveler.birthday));
            const currentYear = getYear(Date.now());
            const travelerDateOfBirth = new Date(currentYear, monthOfBirth, dayOfBirth);
            const difference = travelerDateOfBirth.getTime() - new Date().getTime();

            if ((Math.floor(difference / (1000 * 60 * 60 * 24)) + 1) <= 7 && (Math.floor(difference / (1000 * 60 * 60 * 24)) + 1) >= 0) {
                travelersWithBirthday.push(traveler);
            }
        });
    }

    callback(travelersWithBirthday);
}